export default function CBreakContinue() {
  return <h2>C Break Continue</h2>;
}
